import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getRequest } from "apis/ApiInstence";

/**
 * Group records as:
 * Month
 *   └── Date
 *        └── Works
 */
const groupMonthWiseData = (data) => {
  return data.reduce((acc, item) => {
    if (!item.date) return acc;

    const dateObj = new Date(item.date);
    const monthName = dateObj.toLocaleString("en-US", { month: "long" });
    const year = dateObj.getFullYear();
    const monthKey = `${monthName} ${year}`;

    if (!acc[monthKey]) {
      acc[monthKey] = {
        month: monthName,
        year,
        totalAmount: 0,
        dates: {},
      };
    }

    if (!acc[monthKey].dates[item.date]) {
      acc[monthKey].dates[item.date] = {
        date: item.date,
        totalAmount: 0,
        works: [],
      };
    }

    acc[monthKey].dates[item.date].works.push(...(item.works || []));
    acc[monthKey].dates[item.date].totalAmount += Number(
      item.total_amount || 0
    );
    acc[monthKey].totalAmount += Number(item.total_amount || 0);

    return acc;
  }, {});
};

const ServiceManWorkDetails = () => {
  const { id } = useParams();

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openMonth, setOpenMonth] = useState(null);
  const [openDate, setOpenDate] = useState(null);

  useEffect(() => {
    fetchWorkDetails();
  }, []);

  const fetchWorkDetails = async () => {
    try {
      const res = await getRequest(
        `servicemen/servicemanworksdetails/${id}`
      );

      if (res?.data?.success) {
        setRecords(res.data.data || []);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="text-center mt-4">Loading...</p>;
  }

  if (records.length === 0) {
    return <p className="text-center mt-4">No records found</p>;
  }

  const groupedData = groupMonthWiseData(records);

  return (
    <div className="container-fluid">
      <h4 className="mb-4">Service Man Work Details</h4>

      {Object.entries(groupedData).map(([monthKey, monthData]) => {
        const isMonthOpen = openMonth === monthKey;

        return (
          <div className="card shadow mb-3" key={monthKey}>
            {/* ================= MONTH HEADER ================= */}
            <button
              className="card-header d-flex justify-content-between align-items-center bg-primary text-white border-0"
              onClick={() =>
                setOpenMonth(isMonthOpen ? null : monthKey)
              }
            >
              <strong>{monthKey}</strong>
              <strong>₹ {monthData.totalAmount}</strong>
            </button>

            {/* ================= MONTH BODY ================= */}
            {isMonthOpen &&
              Object.values(monthData.dates).map((dateItem) => {
                const isDateOpen = openDate === dateItem.date;

                return (
                  <div key={dateItem.date} className="border-top">
                    {/* ---------------- DATE HEADER ---------------- */}
                    <button
                      className="w-100 d-flex justify-content-between align-items-center p-3 bg-light border-0"
                      onClick={() =>
                        setOpenDate(isDateOpen ? null : dateItem.date)
                      }
                    >
                      <strong>
                        {dateItem.date === "0000-00-00"
                          ? "Unknown Date"
                          : dateItem.date}
                      </strong>

                      <div>
                        <span className="mr-3">
                          Orders: {dateItem.works.length}
                        </span>
                        <strong>₹ {dateItem.totalAmount}</strong>
                        <span className="ml-3">
                          {isDateOpen ? "▲" : "▼"}
                        </span>
                      </div>
                    </button>

                    {/* ---------------- WORK DETAILS ---------------- */}
                    {isDateOpen && (
                      <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                          <thead className="thead-dark">
                            <tr>
                              <th>Order ID</th>
                              <th>Amount (₹)</th>
                              <th>Your Income (70%)</th>
                              <th>Company (30%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dateItem.works.map((work, index) => (
                              <tr key={index}>
                                <td>{work.order_id}</td>
                                <td>₹ {work.amount}</td>
                                <td>
                                  ₹ {(work.amount * 70) / 100}
                                </td>
                                <td>
                                  ₹ {(work.amount * 30) / 100}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        );
      })}
    </div>
  );
};

export default ServiceManWorkDetails;
